import { Component, effect, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { OnboardingService, OnboardingStepsService } from '@brightside-web/desktop/feature/onboarding2';
import { SurveyQuestionnaireService } from '@brightside-web/desktop/feature/survey-questionnaire';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { SharedDisplayCampaignComponent, SharedDisplayModule } from '@brightside-web/shared/display';
import { OnboardingWelcomeComponent } from '../onboarding-welcome/onboarding-welcome.component';

@Component({
    selector: 'brightside-web-onboarding',
    imports: [CommonModule, RouterOutlet, BrightsideUiModule, OnboardingWelcomeComponent, SharedDisplayModule],
    templateUrl: './onboarding.component.html',
    styleUrl: './onboarding.component.css'
})
export class OnboardingComponent {
  readonly onboardingStepsService = inject(OnboardingStepsService);
  readonly copy = this.onboardingStepsService.currentCopy;
  readonly step = this.onboardingStepsService.currentStep;
  readonly isLoading = this.onboardingStepsService.isLoading;
  private _surveyService = inject(SurveyQuestionnaireService);

  constructor() {
    this._surveyService.disableBackToHome();

  }

  advance() {
    this.onboardingStepsService.completeStep(); // marks current complete + advances
  }

  back() {
    this.onboardingStepsService.back();
  }

  hasPrevious() {
    return this.onboardingStepsService.currentIndex() > 0;
  }
}
